enum ComplianceStatus {
  Complete = "Complete",
  MissingReceipt = "Missing Receipt",
  MissingAllocation = "Missing Allocation",
  MissingAttendee = "Missing Attendee",
  MismatchReceipt = "Mismatch Receipt",
  Overwritten = "Overwritten",
  LostReceipt = "Lost Receipt",
  Exempt = "Exempt",
}

export default ComplianceStatus;
